export const GET_PRODUCTS_CATEGORIES_REQUEST = "GET_PRODUCTS_CATEGORIES_REQUEST";
export const GET_PRODUCTS_CATEGORIES_SUCCESS = "GET_PRODUCTS_CATEGORIES_SUCCESS";

export const SHOW_PRODUCT_CATEGORY_REQUEST = "SHOW_PRODUCT_CATEGORY_REQUEST";
export const SHOW_PRODUCT_CATEGORY_SUCCESS = "SHOW_PRODUCT_CATEGORY_SUCCESS";

export const POST_PRODUCT_CATEGORY_REQUEST = "POST_PRODUCT_CATEGORY_REQUEST";
export const POST_PRODUCT_CATEGORY_SUCCESS = "POST_PRODUCT_CATEGORY_SUCCESS";

export const PUT_PRODUCT_CATEGORY_REQUEST = "PUT_PRODUCT_CATEGORY_REQUEST";
export const PUT_PRODUCT_CATEGORY_SUCCESS = "PUT_PRODUCT_CATEGORY_SUCCESS";

export const DELETE_PRODUCT_CATEGORY_REQUEST = "DELETE_PRODUCT_CATEGORY_REQUEST";
export const DELETE_PRODUCT_CATEGORY_SUCCESS = "DELETE_PRODUCT_CATEGORY_SUCCESS";
